import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import JisDialogForm from "../../components/formdialog";
import JisTabButton from "../../components/controls/jisTabButton";
import DeadlineBadge from "../../components/controls/deadlinebadge";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import useComments from "../../hooks/useComment";

import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";

// Move CommentDropdown outside to prevent re-creation on every render
const CommentDropdown = ({
  setNewValue,
  onChange,
  name,
  placeholder,
  required,
  reasonPlaceHolder,
  initialValue = "",
  predefinedComments = [],
}) => {
  const [selectedComments, setSelectedComments] = useState([]);
  const [value, setValue] = useState(initialValue);

  // Reset value when initialValue changes (e.g., when modal opens)
  useEffect(() => {
    setValue(initialValue);
    setSelectedComments([]);
  }, [initialValue]);

  // Load predefined selections from value
  useEffect(() => {
    if (value && predefinedComments.length > 0) {
      const parts = value
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);

      const predefinedSelected = parts.filter((p) =>
        predefinedComments.some((comment) =>
          typeof comment === "string" ? comment === p : comment.source === p
        )
      );

      setSelectedComments(predefinedSelected);
    }
  }, [value, predefinedComments]);

  // Update parent component - works with both setValue and onChange patterns
  const updateParent = (finalValue) => {
    if (setNewValue) {
      setNewValue(finalValue);
    }
    if (onChange) {
      onChange({ target: { name, value: finalValue } });
    }
  };

  // Merge and update the parent
  const updateFinal = (updatedSelected, customText) => {
    const cleanedCustom = customText.split(",").map((v) => v.trim());

    const finalValue = [...updatedSelected, ...cleanedCustom]
      .filter(Boolean)
      .join(", ");

    updateParent(finalValue);
  };

  // Handle checkbox change
  const handleCheckboxChange = (e) => {
    const { checked, value: comment } = e.target;

    const updatedSelected = checked
      ? [...selectedComments, comment]
      : selectedComments.filter((c) => c !== comment);

    setSelectedComments(updatedSelected);

    // Get current custom text (non-predefined parts)
    const currentParts = (value || "")
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    const customOnly = currentParts.filter(
      (p) =>
        !predefinedComments.some((comment) =>
          typeof comment === "string" ? comment === p : comment.source === p
        )
    );

    updateFinal(updatedSelected, customOnly.join(", "));
  };

  // Handle textarea typing
  const handleCustomChange = (e) => {
    const inputText = e.target.value;

    // Update parent immediately for responsive typing
    updateParent(inputText);

    // Update internal selected comments based on what's typed
    const parts = inputText
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    const predefinedInText = parts.filter((p) =>
      predefinedComments.some((comment) =>
        typeof comment === "string" ? comment === p : comment.source === p
      )
    );
    setSelectedComments(predefinedInText);
  };

  return (
    <div>
      {reasonPlaceHolder && (
        <p className="reason_placeholder">{reasonPlaceHolder}</p>
      )}
      <div className="predefined_comment_wrapper">
        {predefinedComments.map((comment, index) => {
          const commentText =
            typeof comment === "string" ? comment : comment.source;
          return (
            <label key={index} className="predefined_checkbox_wrapper">
              <input
                type="checkbox"
                value={commentText}
                checked={selectedComments.includes(commentText)}
                onChange={handleCheckboxChange}
              />
              <p>{commentText}</p>
            </label>
          );
        })}
      </div>

      <div>
        <label style={{ marginBottom: "120px" }} htmlFor="comments">
          comment
        </label>
        <textarea
          className="predefinedComments_textarea"
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={(e) => handleCustomChange(e)}
        />
      </div>
    </div>
  );
};

function DeputySheriff() {
  const navigate = useNavigate();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert ,holidays} =
    useContext(ShareContext);

  // Fetch predefined comments
  const { comments: predefinedComments } = useComments(token);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [isLiti, setIsLitiation] = useState(null);
  const [openOption, setOpenOption] = useState(false);
  const [comment, setComment] = useState("");
  const [option, setOption] = useState({});
  const [suitNumber, setSuitnumber] = useState("");
  const [selected, setSelected] = useState(new Set()); //to hold the selected
  const [selectedCases, setSelectedCases] = useState({});
  const [assignTo, setAssignTo] = useState(null);
  const [sheriffs, setSheriffs] = useState([]);
  const [tab, setTab] = useState("pending");
  const [isReassignModalOpen, setIsReassignModalOpen] = useState(false);
  const [locs, setLocs] = useState({ state: null, lga: null, city: null });
  const [Lga, setLga] = useState([]);
  const [states, setStates] = useState([]);
  const [lgaId, setLgaId] = useState(0);

  const [caseInfo, setCaseInfo] = useState({
    stateId: Constants.Default_State,
    processType: "Normal",
    isPublic: 1,
    caseFilingId: 1,
    isDelarative: true,
    isRequireInterpretation: true,
    isLegalPolicy: true,
    isLegalPosition: true,
    isEmergency: true,
    isDispute: true,
    isUniform: true,
  });
  console.log(Lga);
  const onGetStates = async () => {
    //for account registration
    try {
      setLocs((prevLocs) => ({ ...prevLocs, state: false }));
      const resp = await fetch(`${Constants.apiUrl}/profile/states`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setLocs((prevLocs) => ({ ...prevLocs, state: true }));
      setStates(data);
    } catch (error) {
      setLocs((prevLocs) => ({ ...prevLocs, state: null }));
      console.error(error);
    }
  };

  useEffect(() => {
    //onLoad();
    onLoadSheriffByDivision();
  }, []);

  useEffect(() => {
    if (search != null && lgaId !== null) {
      if (pageIndex >= 0) {
        console.log(
          "loding from direct useEffect with pageIndex,pageSize,search"
        );
        console.log(`is search ${isSearch}`);
        onSearch(search);
      } else {
        setPageIndex(0);
      }
    }
  }, [pageIndex, pageSize, search, tab, lgaId]);

  useEffect(() => {
    var cc = localStorage.getItem("caseinfo");
    if (cc != null) {
      var all = JSON.parse(cc);
      //{cinfo,selectedCauses,otherCauses,fiat,claims}
      setCaseInfo(all.caseInfo);
    }
    onGetStates();
  }, []);

  const claimTypes = [
    { id: 1, title: "Mortgage" },
    { id: 2, title: "Liquidated Damage" },
    { id: 3, title: "Foreigner Involved" },
    { id: 4, title: "Non Capital Offense" },
    { id: 5, title: "Non Capital Offense" },
    { id: 6, title: "Other" },
    { id: 7, title: "None" },
  ];
  const onCheck = (value, opt) => {
    let sel = selected;
    let updateSel = { ...selectedCases };
    if (value) {
      sel.add(opt.caseId);
      updateSel[opt.caseId] = opt;
    } else {
      sel.delete(opt.caseId);
      delete updateSel[opt.caseId];
    }
    setSelected(new Set(sel));
    setSelectedCases(updateSel);

    console.log(Object.keys(updateSel));
  };

  useEffect(() => {
    console.log(
      selected[Array.from(Object.keys(selected))[0]],
      "selected case"
    );
    console.log(Array.from(selected));
    console.log(selectedCases, "selectedCase case");
  }, [selectedCases, selected]);

  useEffect(() => {
    onGetLgs();
  }, []);

  console.log(locs);

  const onLoadSheriffByDivision = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/get-Service-Sheriff`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setSheriffs(data.pros);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onCaseChange = (e) => {
    setCaseInfo({ ...caseInfo, [e.target.name]: e.target.value });
  };

  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/service-sheriff/${lgaId}/${tab}/${pageIndex}/${pageSize}`,
        {
          method: "POST",
          body: JSON.stringify(sear),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await resp.json();
      setLoading(false);
      setIsSearch(true);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onContinue = (fee, ind) => {
    navigate(`/case-details/${fee.caseId}`);
    // setActive(fee);
    // setIndex(ind);
    // setOpenCase(true);
  };

  const onCloseOpenCase = () => {
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
  };

  const onGetLgs = async () => {
    //for account registration
    try {
      setLocs((prevLocs) => ({ ...prevLocs, lga: false }));
      const resp = await fetch(`${Constants.apiUrl}/profile/lgs/15`, {
        method: "GET",
        headers: { "Content-Type": "application/json", Authorization: "" },
      });
      const data = await resp.json();
      setLga(data);
      setLocs((prevLocs) => ({ ...prevLocs, lga: true }));
    } catch (error) {
      setLocs((prevLocs) => ({ ...prevLocs, lga: null }));
      console.error(error);
    }
  };

  const onSave = async (e) => {
    e.preventDefault();
    console.log("testing one two");
    console.log(option);

    if (option.roleId == "") {
      setErr("Please selecte one of the listed Service Sherrif");
      return;
    }

    var caseids = Array.from(selected);
    setErr("");
    //var judgeAs=isCmc==true?'CMC':'Trial';
    var approve = {
      ...option,
      caseids: caseids,
      assignType: "service-sheriff",
      assignTo: option.roleId,
    };
    console.log(approve);

    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/Assign-Cases`, {
        method: "POST",
        body: JSON.stringify(approve),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenOption(false);
        setSelected(new Set());
        setSelectedCases({});
        setAlert({
          open: true,
          title: "Deputy Sheriff Assignment",
          subtitle: "Cases assigned successfully",
        });
        setPageIndex(-1); // this will auto load again
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const onOptionChange = (e) => {
    setOption({ ...option, [e.target.name]: e.target.value });
  };

  const onReassign = async (e) => {
    e.preventDefault();
    setErr("");

    if (!option.roleId) {
      setErr("Please select a Service Sheriff");
      return;
    }

    const reassignData = {
      ...option,
      caseids: Array.from(selected),
      assignType: "service-sheriff",
      assignTo: option.roleId,
    };

    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/Assign-Cases`, {
        method: "POST",
        body: JSON.stringify(reassignData),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);

      if (data.code == 0) {
        setIsReassignModalOpen(false);
        setSelected(new Set());
        setOption({});
        setAlert({
          open: true,
          title: "Deputy Sheriff Re-assignment",
          subtitle: "Case re-assigned successfully",
        });
        setPageIndex(-1); // reload the list
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
    }
  };

  return (
    <div>
      {/* <CaseSearch onSearch={onSearch} frequentData={frequentData} /> */}
      <CustomSearchSortHeader onSearch={onSearch} frequentData={frequentData} />

      {/* <div style={{ textAlign: "right" }}>
        {Object.keys(selectedCases).length > 0 && (
          <JisButton onClick={() => setOpenOption(true)}>
            {" "}
            Bulk Assign ({Object.keys(selectedCases).length})
          </JisButton>
        )}
      </div> */}

      <div className="tab_body">
        <div className="exportdiv">
          <img
            src={wordicon}
            // onClick={() => onExport("word")}
            style={{ cursor: "pointer" }}
          />
          <img
            src={excelicon}
            // onClick={() => onExport("excel")}
            style={{ cursor: "pointer" }}
          />
          <img
            src={pdficon}
            // onClick={() => onExport("pdf")}
            style={{ cursor: "pointer" }}
          />
        </div>

        <div className="case-assignment-tab-container">
          <div className="tab_section">
            <JisTabButton
              isActive={tab == "pending"}
              title="Pending Cases"
              isRoleBased={false}
              onClick={() => setTab("pending")}
            />
            <JisTabButton
              isActive={tab == "assigned"}
              title="Assigned Cases"
              isRoleBased={false}
              onClick={() => {
                setTab("assigned");
                setSelected(new Set());
                setSelectedCases({});
              }}
            />
            <JisTabButton
              isActive={tab == "substituted"}
              title="Substituted Cases"
              isRoleBased={false}
              onClick={() => {
                setTab("substituted");
                setSelected(new Set());
                setSelectedCases({});
              }}
            />
          </div>

          <div className="case-assignment-btn-container">
            {Object.keys(selectedCases).length > 0 && tab == "pending" && (
              <>
                <button
                  className="case-assignment-btn-solid"
                  onClick={() => setOpenOption(true)}
                >
                  {" "}
                  {Object.keys(selectedCases).length === 1
                    ? "Assign (1)"
                    : `Bulk Assign (${Object.keys(selectedCases).length})`}
                </button>

                <button
                  onClick={() => {
                    setSelected(new Set());
                    setSelectedCases({});
                  }}
                  className="case-assignment-btn-outline"
                >
                  Cancel selection
                </button>
              </>
            )}
            <div className="select_wrapper">
              <select
                name="LocalGovtAreaId"
                value={lgaId}
                required={true}
                onChange={(e) => setLgaId(Number(e.target.value))}
                className="select-lga-outline"
              >
                {locs.lga == null && (
                  <option value="">Select State first</option>
                )}
                {locs.lga == false && <option value="">Loading LG...</option>}
                {locs.lga && <option value="0">Select LG</option>}
                {Lga.map((opt) => (
                  <option key={opt.id} value={opt.id}>
                    {opt.title}
                  </option>
                ))}
              </select>

              <div className="select_icon select-lga-icon">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.00002 12.6005C8.47502 12.6005 7.95001 12.398 7.55251 12.0005L2.66251 7.11047C2.44501 6.89297 2.44501 6.53297 2.66251 6.31547C2.88001 6.09797 3.24001 6.09797 3.45751 6.31547L8.34751 11.2055C8.70751 11.5655 9.29251 11.5655 9.65251 11.2055L14.5425 6.31547C14.76 6.09797 15.12 6.09797 15.3375 6.31547C15.555 6.53297 15.555 6.89297 15.3375 7.11047L10.4475 12.0005C10.05 12.398 9.52501 12.6005 9.00002 12.6005Z"
                    fill="#5CA9FB"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div className="tab_view">
          {cases?.length == 0 && <JisEmptyList />}
          {cases?.length > 0 && (
            <div className="table">
              <div class="section-cases">
                <span>Deputy Sheriff </span>
                {/* <span className="total">{count}</span> */}
              </div>
              <div className="table-wrapper">
                <table class="case-table">
                  <thead>
                    <tr>
                      <th className="col-title">Suit Number</th>
                      <th className="col-title">Case Title</th>
                      <th className="col-medium">Filing Type</th>
                      {/* <th className="col-medium">Classification</th> */}
                      {/* <th className="col-medium">Date Initiated</th> */}
                      <th>L.G.A</th>
                      <th className="col-title">Address</th>
                     {tab=="pending" && <th>SLA</th>} {tab!="pending" && <th>Assigned User</th>}  
                      <th className="col-medium">Status Level</th>
                      <th className="col-title">Details</th>
                      <th className="col-action">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cases?.map((opt, index) => {
                      const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                      return (
                        <tr key={index}>
                          <td
                            style={{
                              backgroundColor: `${
                                Constants.getItemById(
                                  frequentData?.casecategories,
                                  opt.caseCategoryId
                                )?.colour
                              }`,
                            }}
                          >
                            {opt.caseNumber || "N/A"}
                          </td>
                          <td>{opt.caseTitle || "N/A"}</td>
                          <td>
                            {Constants.getItemById(
                              frequentData?.casetype,
                              opt.caseTypeId
                            )?.caseType1 || "N/A"}
                          </td>
                          {/* <td>
                            {" "}
                            {
                              Constants.getItemById(
                                frequentData?.casecategories,
                                opt.caseCategoryId
                              )?.categoryTitle
                            }
                          </td> */}
                          {/* <td>
                            {" "}
                            {Constants.momentDate(opt.createdOn).format(
                              "DD MMM, YYYY"
                            )}
                          </td> */}
                          <td>
                            {opt.party
                              ? Constants.getItemById(Lga, opt.party.lga)?.title
                              : "N/A"}
                          </td>
                          <td>{opt.party ? opt.party.address1 : "N/A"}</td>
                          
                          {tab=="pending" && <td>  <DeadlineBadge dateString={opt.slaExpire} />   </td>} {tab!="pending" && <td>  {opt.assignedUser?.firstName}  {opt.assignedUser?.lastName} </td>} 
                          <td>
                            {
                              Constants.getItemById(
                                frequentData?.casestatuses,
                                opt.caseStatusId
                              )?.description
                            }
                          </td>

                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onContinue(opt, index)}
                            >
                              View
                            </JisButton>
                          </td>
                          <td>
                            {tab == "pending" ? (
                              <JisCheckbox
                                onChange={(e) => onCheck(e, opt)}
                                value={selected.has(opt.caseId)}
                              />
                            ) : (
                              <JisButton
                                onClick={() => {
                                  setSelected(new Set([opt.caseId]));
                                  setSelectedCases({ [opt.caseId]: opt });
                                  setOption({});
                                  setErr("");
                                  setIsReassignModalOpen(true);
                                }}
                                variant="plain"
                              >
                                Re-Assign
                              </JisButton>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {cases?.length > 0 && (
                <Pagenated
                  onChangePageSize={(k) => setPageSize(k)}
                  size={pageSize}
                  total={count}
                  maxPage={20}
                  onPick={onPagePick}
                />
              )}
            </div>
          )}
        </div>
      </div>

      <BackLoader open={loading} />

      {openCase && active != null && (
        <JisDialogForm title="Case Info" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )}

      {openOption && (
        <div className="service_sheriff_wrapper">
          <div className="service_sheriff_bg_image">
            <div className="service_sheriff_modal">
              <p className="header">Assign To Service Sheriff</p>
              <form onSubmit={onSave}>
                <div className="bulk_assignment_form_wrapper">
                  <div className="form_right_content">
                    <div>
                      {/* {Object.keys(selectedCases).length <= 1 && (
                        <div className="select-group">
                          <label>Suit Number</label>
                          <input
                            type="text"
                            readOnly
                            value={
                              selectedCases[Object.keys(selectedCases)[0]]
                                ?.caseNumber || ""
                            }
                          />
                        </div>
                      )} */}

                      <div className="select-group">
                        <label>Service Sheriff</label>
                        <select
                          name="roleId"
                          value={option.roleId}
                          onChange={onOptionChange}
                          required
                        >
                          <option value="">Select service sheriff </option>
                          {sheriffs?.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.suffix} {opt.firstName} {opt.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="input-group">
                      <label>Comment</label>
                      <div>
                        <CommentDropdown
                          placeholder="Comment"
                          required={true}
                          reasonPlaceHolder={"Reason (select all that apply)"}
                          onChange={onOptionChange}
                          name="comment"
                          initialValue={option.comment || ""}
                          predefinedComments={predefinedComments}
                        />
                      </div>
                    </div>
                    {err != "" && <div className="error">{err}</div>}
                    <button
                      type="button"
                      className="bulk_cancel_btn"
                      onClick={() => setOpenOption(false)}
                    >
                      Cancel
                    </button>
                    <button className="bulk_assign_btn" type="submit">
                      Assign{" "}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {isReassignModalOpen && (
        <div className="service_sheriff_wrapper">
          <div className="service_sheriff_bg_image">
            <div className="service_sheriff_modal">
              <p className="header">Re-assign to Service Sheriff</p>
              <form onSubmit={onReassign}>
                <div className="bulk_assignment_form_wrapper">
                  <div className="form_right_content">
                    <div>
                      <div className="select-group">
                        <label>Service Sheriff</label>
                        <select
                          name="roleId"
                          value={option.roleId}
                          onChange={onOptionChange}
                          required
                        >
                          <option value="">Select service sheriff</option>
                          {sheriffs?.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.suffix} {opt.firstName} {opt.lastName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    <div className="input-group">
                      <label>Comment</label>
                      <div>
                        <CommentDropdown
                          placeholder="Reason for re-assignment..."
                          required={true}
                          reasonPlaceHolder={"Reason (select all that apply)"}
                          onChange={onOptionChange}
                          name="comment"
                          initialValue={option.comment || ""}
                          predefinedComments={predefinedComments}
                        />
                      </div>
                    </div>
                    {err != "" && <div className="error">{err}</div>}
                    <button
                      type="button"
                      className="bulk_cancel_btn"
                      onClick={() => {
                        setIsReassignModalOpen(false);
                        setSelected(new Set());
                        setOption({});
                        setErr("");
                      }}
                    >
                      Cancel
                    </button>
                    <button className="bulk_assign_btn" type="submit">
                      Re-assign
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default DeputySheriff;
